import { Shinsei, DakokuSyuusei } from "@/types/Shinsei";
import { reactive } from "vue";

export function useInit(form: Shinsei) {

  let dakokuSyuusei: DakokuSyuusei = reactive({
    dakoku_id: null,
    dakoku_date: null,
    syuugyou_basyo_id: null,
    gaisyutsu_datetime: null,
    kyuukei_times: null,
    modori_datetime: null,
    syukkin_datetime: null,
    taikin_datetime: null,
    is_torikeshi: false,
    before_gaisyutsu_datetime: null,
    before_kyuukei_times: null,
    before_modori_datetime: null,
    before_syukkin_datetime: null,
    before_taikin_datetime: null,
    koyou_keiyaku_time_id: null
  });

  if(form.dakoku_syuusei){
    dakokuSyuusei = form.dakoku_syuusei;
  }else{
    form.dakoku_syuusei = dakokuSyuusei;
  }

  return {
    dakokuSyuusei
  }
}